import { PlusCircle } from "@phosphor-icons/react";

import EmptyPlaceholder from "common/components/EmptyPlaceholder";
import RestrictedComponent from "common/components/RestrictedComponent";
import { Button } from "common/components/ui/Button";
import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";
import useAppStore from "common/hooks/useAppStore";

import NoCampaignsImage from "assets/images/empty-placeholders/campaigns.png";

export default function CampaignsEmptyPlaceholder() {
  const setIsCampaignModalOpen = useAppStore(
    (state) => state.setIsCampaignModalOpen,
  );

  const { accounts_count: accountsCount } = useSelectedWorkspaceContext();

  const hasAccount = accountsCount > 0;

  return (
    <EmptyPlaceholder
      title="No campaigns yet"
      subtitle="Create your first campaign to start automating LinkedIn outreach and generating leads on autopilot"
      imageSrc={NoCampaignsImage}
      actionComponent={
        <RestrictedComponent
          visibleForPermissions={
            hasAccount
              ? ["campaigns_full"]
              : ["campaigns_full", "accounts_full"]
          }
        >
          <Button
            data-intercom-target="create-campaign-button"
            onClick={() => setIsCampaignModalOpen(true)}
            leftIcon={<PlusCircle weight="fill" />}
          >
            Create campaign
          </Button>
        </RestrictedComponent>
      }
    />
  );
}
